module.exports = __webpack_public_path__ + "static/media/il2_squadron.19a55dd5.jpg";